module.exports = __webpack_public_path__ + "img/auth-banner3.76384862.webp";